export default {
  setGroupList (state: any, payload: any) {
    state.groupData = payload
  },
  setSearchText (state: any, payload: string) {
    state.searchText = payload
  },
  setSortNum (state: any, num: number) {
    state.sortNum = num
  },
  setSortAsc (state: any, sort: boolean) {
    state.sortAsc = sort
  }
}
